
import { DataFilterActions } from '@/store/actions/dataFilterActions';
import { AreaType, ScenarioType, SectorType, FilterPayloadType } from '@/types';
import { Vue, Component } from 'vue-property-decorator';
import { DataFilterMutations } from '@/store/mutations/dataFilterMutations';

@Component
export default class DataFilter extends Vue {
  applyFilter() {
    this.$store.dispatch(DataFilterActions.SET_DATA_FILTER);
  }

  get applyButtonDisabled(): boolean {
    return this.selectedArea === this.appliedFilters.area &&
      this.selectedSector === this.appliedFilters.sector &&
      this.selectedScenarios === this.appliedFilters.scenarios
      ? true
      : false;
  }
  get areas(): AreaType[] {
    return this.$store.getters.areas.sort((a: AreaType, b: AreaType) => {
      return a.name.localeCompare(b.name);
    });
  }

  get sectors(): SectorType[] {
    return this.$store.getters.sectors;
  }

  get scenarios(): ScenarioType[] {
    return this.$store.getters.scenarios;
  }

  get selectedArea(): AreaType | null {
    return this.$store.getters.selectedArea;
  }

  set selectedArea(value: AreaType | null) {
    this.$store.commit(DataFilterMutations.SET_SELECTED_AREA, value);
  }

  get selectedSector(): SectorType | null {
    return this.$store.getters.selectedSector;
  }

  set selectedSector(value: SectorType | null) {
    this.$store.commit(DataFilterMutations.SET_SELECTED_SECTOR, value);
  }

  get selectedScenarios(): ScenarioType[] {
    return this.$store.getters.selectedScenarios;
  }

  set selectedScenarios(value: ScenarioType[]) {
    this.$store.commit(DataFilterMutations.SET_SELECTED_SCENARIOS, value);
  }

  get appliedFilters(): FilterPayloadType {
    return this.$store.getters.appliedFilters;
  }
}
